import React, { Component } from 'react';
import {
    Card,
    CardBody,
    CardImage,
    CardTitle,
    CardText,
    Container,
    Col,
    View, Mask, Row, Fa, Breadcrumb, BreadcrumbItem
} from "mdbreact";
import { Link } from "react-router-dom";
import "./../../assets/images/help/hub_bigHeader.png";
import { IMAGE_URL } from "../../config/Config";


export default class HowItWorks extends Component {
    render() {
        return (
            <div className="pt-3">
                <Container>
                    <Breadcrumb className='w-100 white mt-3 rtl'>
                        <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                        <BreadcrumbItem active>سوالات متداول</BreadcrumbItem>
                    </Breadcrumb>

                    <Row className="mt-1 mb-5 d-flex justify-content-around">
                        <Col md="9" sm="12">
                            <div className="w-100 p-3 white">

                                <View zoom className='w-100'>
                                    <img src="./../../assets/images/help/faqs.jpg" className="img-fluid" alt="" />
                                    <Mask className="flex-center" />

                                </View>

                            </div>

                        </Col>
                        <Col md="3" sm="12" className="d-flex justify-content-around">
                            <div className="w-100 p-3 white">
                                <h4 className="rtl">دسته بندی ها</h4>
                                <ul className="sidebar-menu rtl">
                                    <li><Link to="/faqs/1">دسته بندی </Link></li>
                                    <li><Link to="/faqs/1">دسته بندی </Link></li>
                                    <li><Link to="/faqs/1">دسته بندی </Link></li>
                                    <li><Link to="/faqs/1">دسته بندی </Link></li>
                                </ul>
                            </div>
                        </Col>
                    </Row>

                    <Row className="rtl">
                        <Col lg="4" md="6" sm="12" className="mb-5">
                            <Card>
                                <CardImage className="img-fluid" src={IMAGE_URL + "uploads/faqs/faq.jpg"} />
                                <CardBody>
                                    <CardTitle>
                                        <Link to='/faq/1'>عنوان آموزش</Link>
                                    </CardTitle>
                                    <CardText className="text-justify">
                                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
                                    </CardText>
                                    <hr />
                                    <div className="d-flex justify-content-between">

                                        <div className="grey-text p-2">
                                            <Fa icon="calendar" />
                                            <span>22 May, 2016</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="film" className="amber-text" />
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="thumbs-o-up " className="blue-text" />
                                            <span>239</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="eye" className="blue-text" />
                                            <span>11792</span>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg="4" md="6" sm="12" className="mb-5">
                            <Card>
                                <CardImage className="img-fluid" src={IMAGE_URL + "uploads/faqs/faq.jpg"} />
                                <CardBody>
                                    <CardTitle>
                                        <Link to='/faq/2'>عنوان آموزش</Link>
                                    </CardTitle>
                                    <CardText className="text-justify">
                                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
                                    </CardText>
                                    <hr />
                                    <div className="d-flex justify-content-between">

                                        <div className="grey-text p-2">
                                            <Fa icon="calendar" />
                                            <span>22 May, 2016</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="film" className="amber-text" />
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="thumbs-o-up " className="blue-text" />
                                            <span>239</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="eye" className="blue-text" />
                                            <span>11792</span>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg="4" md="6" sm="12" className="mb-5">
                            <Card>
                                <CardImage className="img-fluid" src={IMAGE_URL + "uploads/faqs/faq.jpg"} />
                                <CardBody>
                                    <CardTitle>
                                        <Link to='/faq/3'>عنوان آموزش</Link>
                                    </CardTitle>
                                    <CardText className="text-justify">
                                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
                                    </CardText>
                                    <hr />
                                    <div className="d-flex justify-content-between">

                                        <div className="grey-text p-2">
                                            <Fa icon="calendar" />
                                            <span>22 May, 2016</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="film" className="amber-text" />
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="thumbs-o-up " className="blue-text" />
                                            <span>239</span>
                                        </div>
                                        <div className="grey-text p-2">
                                            <Fa icon="eye" className="blue-text" />
                                            <span>11792</span>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>


                    </Row>
                </Container>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/faq/faq.js